import React from 'react';
import { Tbody, Tr, Td, Center, Flex } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/system';
import MuiIcon from 'components/MuiIcon';
import { useTranslation } from 'react-i18next';
import useGetColors from 'shared/hooks/useGetColors';

interface Props {
  length: number,
}

const NoDataBody = ({ length }: Props) => {
  const { t } = useTranslation();
  const { blue800 } = useGetColors();

  return (
    <Tbody>
      <Tr
        color={blue800}
        fontWeight="bold"
        borderBottom="none"
      >
        <Td colSpan={length} h={200}>
          <Center position="absolute" top="50%" left="50%">
            <Flex flexDirection="column">
              <MuiIcon size={48} name="sd_card_alert" />
              <chakra.span>{t('general.table.noData')}</chakra.span>
            </Flex>
          </Center>
        </Td>
      </Tr>
    </Tbody>
  );
}

export default NoDataBody;
